import RadioButton from "../../../../../components/radioButton/RadioButton";
import CheckBox from "../../../../../components/checkBox/CheckBox";
import $ from "jquery"
import MediaQueryUtils from "../../../../../utils/MediaQueryUtils";
import React, {useEffect, useState} from "react";
import Utils from "../../../../../utils/Utils";
import {setStateAssistente} from "../../../../../actions/IndexActions";
import {useDispatch, useSelector} from "react-redux";

function EsperienzeLavorative(props){

    const [state, setState] = useState({})
    const dispatch = useDispatch();
    const getAssistente = useSelector(state => state.wizardReducer)
    let isPageWide = MediaQueryUtils('(min-width: 1150px)')

    useEffect(() =>{
        if(getAssistente && getAssistente.esperienzeLavorative){
            let newState = getAssistente.esperienzeLavorative
            setState(newState)
        }
    },[])

    useEffect(() =>{

        validateCampiCondizionati()
        dispatch(setStateAssistente("esperienzeLavorative",state))
    },[state, setState])

    $(function() {
        let e = $('[data-toggle="popover"]').popover({
            html: true,
            content : '<span class="popover-content">Il candidato comunicherà direttamente alla famiglia richiedente i contatti delle famiglie presso cui ha lavorato\n' +
                'e che si sono rese disponibili ad essere contattate</span>'
        });
        e = e.data('bs.popover') && e.data('bs.popover').getTipElement()?e.data('bs.popover').getTipElement():null
        $(e).addClass("custom");
    });

    function validateCampiCondizionati(){
        if(Object.keys(state).length !== 0){
            if(state.colf && state.colf.colfCheck && !state.colf.anniColf){
                state.colf.anniColf = "1"
            }
            if(state.assistente && state.assistente.assistenteFamiliare && !state.assistente.anniAssistente){
                state.assistente.anniAssistente = "1"
            }
            if(state.operatore && state.operatore.operatoreSocioSanitario && !state.operatore.anniOperatore){
                state.operatore.anniOperatore = "1"
            }
            if(state.ospedaliero && state.ospedaliero.assistenteOspedaliero && !state.ospedaliero.anniOspedaliero){
                state.ospedaliero.anniOspedaliero = "1"
            }
            if(!(state.colf && state.colf.colfCheck)){
                delete state.colf
            }
            if(!(state.assistente && state.assistente.assistenteFamiliare)){
                delete state.assistente
            }
            if(!(state.operatore && state.operatore.operatoreSocioSanitario)){
                delete state.operatore
            }
            if(!(state.ospedaliero && state.ospedaliero.assistenteOspedaliero)){
                delete state.ospedaliero
            }
        }
    }

    return (
        <div>
            <div className={"row"}>
                <div className={isPageWide?"col-4":"col-5"} style={{marginTop:".6rem"}}>
                    <span style={{fontWeight:"bold",fontSize:"14px",color:"#505050"}}>E' disponibile a prendere servizio come assistente familiare:</span>
                    <span className={"obbligatorietaColor"}>*</span>
                </div>
                <div className={isPageWide?"col-6":"col-2"}>
                    <div className={"row"}>
                        <RadioButton
                            id={"servizioSi"}
                            text={"Si"}
                            onChange={(event) => setState(Utils.riceviValore(state,"servizio", event.target.value))}
                            value={"1"}
                            checked={state && state.servizio && state.servizio === "1"}
                        />
                        <RadioButton
                            id={"servizioNo"}
                            text={"No"}
                            value={"2"}
                            onChange={(event) => setState(Utils.riceviValore(state,"servizio", event.target.value))}
                            checked={state && state.servizio && state.servizio === "2"}
                        />
                    </div>
                </div>
                <div className={isPageWide?"col-2":"col-5"} style={{marginTop:".6rem"}}>
                    <span style={{color:"red",fontWeight:"bold"}}>*Campo Obbligatorio</span>
                </div>
            </div>

            <span style={{fontWeight:"bold",fontSize:"14px",color:"#505050",marginTop:"10px"}}>
                Quali esperienze lavorative ha già avuto?
            </span>
            <div className={"row"}>
                <div className={"col-3"} style={{marginTop:".6rem"}}>
                    <CheckBox
                        id={"colfCheck"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "colf"))}
                        checked={state && state.colf && state.colf.colfCheck ? state.colf.colfCheck : false}
                        text={"Colf"}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"unoDueAnniColf"}
                        text={"1-2 anni"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniColf", event.target.value, "colf"))}
                        value={"1"}
                        checked={state && state.colf && state.colf.anniColf && state.colf.anniColf === "1"}
                        disabled={!state || !state.colf || !state.colf.colfCheck}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"treCinqueAnniColf"}
                        text={"3-5 anni"}
                        value={"2"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniColf", event.target.value, "colf"))}
                        checked={state && state.colf && state.colf.anniColf && state.colf.anniColf === "2"}
                        disabled={!state || !state.colf || !state.colf.colfCheck}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"piuCinqueAnniColf"}
                        text={"più di 5 anni"}
                        value={"3"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniColf", event.target.value, "colf"))}
                        checked={state && state.colf && state.colf.anniColf && state.colf.anniColf === "3"}
                        disabled={!state || !state.colf || !state.colf.colfCheck}
                    />
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-3"} style={{marginTop:".6rem"}}>
                    <CheckBox
                        id={"assistenteFamiliare"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistente"))}
                        checked={state && state.assistente && state.assistente.assistenteFamiliare ? state.assistente.assistenteFamiliare : false}
                        text={"Assistente familiare"}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"unoDueAnniAssistenteFamiliare"}
                        text={"1-2 anni"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniAssistente", event.target.value, "assistente"))}
                        value={"1"}
                        checked={state && state.assistente && state.assistente.anniAssistente && state.assistente.anniAssistente === "1"}
                        disabled={!state || !state.assistente || !state.assistente.assistenteFamiliare}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"treCinqueAnniAssistenteFamiliare"}
                        text={"3-5 anni"}
                        value={"2"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniAssistente", event.target.value, "assistente"))}
                        checked={state && state.assistente && state.assistente.anniAssistente && state.assistente.anniAssistente === "2"}
                        disabled={!state || !state.assistente || !state.assistente.assistenteFamiliare}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"piuCinqueAnniAssistenteFamiliare"}
                        text={"più di 5 anni"}
                        value={"3"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniAssistente", event.target.value, "assistente"))}
                        checked={state && state.assistente && state.assistente.anniAssistente && state.assistente.anniAssistente === "3"}
                        disabled={!state || !state.assistente || !state.assistente.assistenteFamiliare}
                    />
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-3"} style={{marginTop:".6rem"}}>
                    <CheckBox
                        id={"operatoreSocioSanitario"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "operatore"))}
                        checked={state && state.operatore && state.operatore.operatoreSocioSanitario ? state.operatore.operatoreSocioSanitario : false}
                        text={"Operatore socio sanitario"}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"unoDueAnniOperatoreSocioSanitario"}
                        text={"1-2 anni"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniOperatore", event.target.value, "operatore"))}
                        value={"1"}
                        checked={state && state.operatore && state.operatore.anniOperatore && state.operatore.anniOperatore === "1"}
                        disabled={!state || !state.operatore || !state.operatore.operatoreSocioSanitario}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"treCinqueAnniOperatoreSocioSanitario"}
                        text={"3-5 anni"}
                        value={"2"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniOperatore", event.target.value, "operatore"))}
                        checked={state && state.operatore && state.operatore.anniOperatore && state.operatore.anniOperatore === "2"}
                        disabled={!state || !state.operatore || !state.operatore.operatoreSocioSanitario}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"piuCinqueAnniOperatoreSocioSanitario"}
                        text={"più di 5 anni"}
                        value={"3"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniOperatore", event.target.value, "operatore"))}
                        checked={state && state.operatore && state.operatore.anniOperatore && state.operatore.anniOperatore === "3"}
                        disabled={!state || !state.operatore || !state.operatore.operatoreSocioSanitario}
                    />
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-3"} style={{marginTop:".6rem"}}>
                    <CheckBox
                        id={"assistenteOspedaliero"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "ospedaliero"))}
                        checked={state && state.ospedaliero && state.ospedaliero.assistenteOspedaliero ? state.ospedaliero.assistenteOspedaliero : false}
                        text={"Assistente ospedaliero"}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"unoDueAnniAssistenteOspedaliero"}
                        text={"1-2 anni"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniOspedaliero", event.target.value, "ospedaliero"))}
                        value={"1"}
                        checked={state && state.ospedaliero && state.ospedaliero.anniOspedaliero && state.ospedaliero.anniOspedaliero === "1"}
                        disabled={!state || !state.ospedaliero || !state.ospedaliero.assistenteOspedaliero}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"treCinqueAnniAssistenteOspedaliero"}
                        text={"3-5 anni"}
                        value={"2"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniOspedaliero", event.target.value, "ospedaliero"))}
                        checked={state && state.ospedaliero && state.ospedaliero.anniOspedaliero && state.ospedaliero.anniOspedaliero === "2"}
                        disabled={!state || !state.ospedaliero || !state.ospedaliero.assistenteOspedaliero}
                    />
                </div>
                <div className={isPageWide?"col-2":"col-3"} style={{marginTop:".5rem"}}>
                    <RadioButton
                        id={"piuCinqueAnniAssistenteOspedaliero"}
                        text={"più di 5 anni"}
                        value={"3"}
                        onChange={(event) => setState(Utils.riceviValorePadre(state, "anniOspedaliero", event.target.value, "ospedaliero"))}
                        checked={state && state.ospedaliero && state.ospedaliero.anniOspedaliero && state.ospedaliero.anniOspedaliero === "3"}
                        disabled={!state || !state.ospedaliero || !state.ospedaliero.assistenteOspedaliero}
                    />
                </div>
            </div>

            <div className={"row"}>
                <span style={{fontWeight:"bold",fontSize:"14px",color:"#505050",marginTop:".8rem",paddingRight: "6px",paddingLeft: "6px"}}>Dispone di referenze</span>
                <a data-toggle="popover" data-container="body" data-trigger="hover">
                    <svg  width="22" height="22" id="it-info-circle" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.7-15h1.5v2h-1.5zm0 3h1.5v9h-1.5z"/>
                            <path fill="none" d="M0 0h24v24H0z"/>
                    </svg>
                </a>
                <div className={"col-2"}>
                    <CheckBox
                        id={"dispondeDiReferenze"}
                        onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.checked))}
                        checked={state && state.dispondeDiReferenze ? state.dispondeDiReferenze : false}/>
                </div>
            </div>
        </div>
    )


}
export default EsperienzeLavorative
